<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" PagingC>
          <Paging
            :resourceSettings="resourceSettings"
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-col>

        <v-col cols="12" FILTERS>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0">
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <DateField
                    label="Create date"
                    :modelValue="filters.created_at"
                    icon="calendar_today"
                    @update:modelValue="(value) => (filters.created_at = value)"
                  />
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <DateField
                    label="Appointment date"
                    :modelValue="filters.appointment"
                    icon="calendar_today"
                    @update:modelValue="(value) => (filters.appointment = value)"
                  />
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-autocomplete
                    :items="candidates"
                    :label="i18n.candidate"
                    :class="`${arabic ? 'arFont' : 'enFont'}`"
                    v-model="filters.candidate_id"
                    outlined
                    hide-details
                    dense
                    clearable
                    item-text="name"
                    item-value="id"
                  />
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-text-field label="Result" outlined dense hide-details v-model="filters.result" />
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-select
                    label="Rejected"
                    dense
                    outlined
                    hide-details
                    :items="filter_items"
                    v-model="filters.rejected"
                  />
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-select
                    label="Accepted"
                    dense
                    outlined
                    hide-details
                    :items="filter_items"
                    v-model="filters.accepted"
                  />
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-select
                    label="Attended"
                    dense
                    outlined
                    hide-details
                    :items="filter_items"
                    v-model="filters.attended"
                  />
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'} pa-1`">
                  <v-select
                    label="Pending"
                    dense
                    outlined
                    hide-details
                    :items="filter_items"
                    v-model="filters.pending"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col class="mx-auto" cols="2" style="max-width: fit-content;">
          <v-btn @click.prevent="() => (dialog = true)" color="primary">
            <v-icon>add</v-icon>
            <span>New</span>
          </v-btn>
        </v-col>
        <v-col cols="12" updates>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <ListInterviews
                :interviews="resource"
                @editResource="editInterview"
                @deleteInterview="deleteInterview"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <multiDialog
      :dialog="dialog"
      :loading="loading"
      :resourceSettings="resourceSettings"
      :deleting="deleting"
      :resourceKeys="resourceKeys"
      :newResource="newResource"
      @closeDialog="
        () => {
          dialog = false;
          newResource = {};
        }
      "
      @updateResource="updateResource"
      @postResource="postResource"
      @deleteResource="deleteResource"
    />
  </v-row>
</template>

<script>
import Paging from "@/components/Paging";
import multiDialog from "@/components/multiDialog";
import { format } from "timeago.js";
import DateField from "@/components/partials/DateField.vue";
import ListInterviews from '@/components/listInterviews.vue';
import _ from "lodash";

export default {
  components: {
    ListInterviews,
    Paging,
    multiDialog,
    DateField,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      loading: false,
      deleting: false,
      resourceKeys: [
        { name: "appointment", label: "appointment", type: "date", required: true, readonly: false },
        { name: "appointment_time", label: "appointment_time", type: "time", required: true, readonly: false },
        {
          name: "candidate_id",
          label: "candidate",
          type: "select",
          items: "candidates",
          data: [],
          source: "db",
          required: true,
          readonly: false,
        },
        { name: "application", label: "application", type: "text", required: false, readonly: false },
        { name: "information", label: "information", type: "text", required: false, readonly: false },
        { name: "pending", label: "pending", type: "switch", required: false, readonly: false },
        { name: "accepted", label: "accepted", type: "switch", required: false, readonly: false },
        { name: "rejected", label: "rejected", type: "switch", required: false, readonly: false },
        { name: "attended", label: "attended", type: "switch", required: false, readonly: false },
        { name: "link", label: "link", type: "text", required: false, readonly: false },
      ],
      newResource: {},
      page: 1,
      loading: false,
      resource: [],
      filters: {
        created_at: null,
        appointment: null,
        candidate_id: null,
        rejected: null, 
        accepted: null, 
        attended: null, 
        pending: null, 
      },
      filter_items: [
        { text: "Any", value: null },
        { text: "Yes", value: true },
        { text: "No", value: false },
      ],
      candidates: [],
      resourceSettings: {
        resourceName: "interviews",
        create: true,
        pagination: true,
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
  watch: {
    filters: {
      handler: _.debounce(function() {
        this.loadResource();
      }, 500),
      deep: true,
    },
  },
  methods: {
    async deleteResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('deleteResource', {resource: `/can/delete_/interviews/${r.id}`})
        this.dialog = false
        this.deleting = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
        res(true)
      })
    },
    deleteInterview(e) {
      this.newResource = e;
      this.deleting = true;
      this.dialog = true;
    },
    formatDateToCurrentLocale(date) {
      let new_date = new Date(date);
      return [
        new_date.toLocaleDateString(this.arabic ? "ar" : "en", {
          day: "numeric",
          year: "numeric",
          month: "short",
        }),
        new_date.toLocaleTimeString(this.arabic ? "ar" : "en"),
      ];
    },
    deleteEvaluation(e) {
      this.newResource = e;
      this.deleting = true;
      this.dialog = true;
    },
    editInterview(e) {
      this.newResource = {
        ...e,
        appointment: e.appointment.appointment.split(" ")[0],
        appointment_time: e.appointment.appointment.split(" ")[1],
      };
      this.dialog = true;
    },
    getFormat(d) {
      return format(d);
    },
    buildFilter() {
      let filter = ``;
      Object.keys(this.filters).map((key) => {
        let value = this.filters[key];
        if (value != null) {
          filter += `&filter[${key}]=${value}`;
        }
      });
      return filter;
    },
    updateResource(r) {
      return new Promise(async (res, rej) => {
        r.appointment = `${r.appointment} ${r.appointment_time}`;
        this.loading = true;

        await this.$store.dispatch("putResource", {
          resource: `/can/update_/interviews/${r.id}`,
          value: r,
        });

        this.dialog = false;
        this.loading = false;
        this.newResource = {};

        await this.loadResource();

        res(true);
      });
    },
    postResource() {
      return new Promise(async (res, rej) => {
        this.newResource.appointment = this.newResource.appointment + " " + this.newResource.appointment_time;
        delete this.newResource.appointment_time;

        this.loading = true;

        await this.$store.dispatch("postResource", {
          resource: "/can/create_/interviews",
          value: this.newResource,
        });

        this.dialog = false;
        this.loading = false;
        this.newResource = {};

        await this.loadResource();

        res(true);
      });
    },
    loadResource() {
      return new Promise(async (res, rej) => {
        this.loading = true;
        this.resource = await this.$store.dispatch("getResource", {
          resource: "/can/get_all_/interviews",
          page: `?page=${this.page}` + this.buildFilter(),
        });
        this.loading = false;

        await this.loadItems();

        res(true);
      });
    },
    pageByNumber(n) {
      return new Promise(async (res, rej) => {
        this.loading = true;
        this.page = n;
        this.resource = await this.$store.dispatch("getResource", {
          resource: "/can/get_all_/interviews",
          page: `?page=${n}` + this.buildFilter(),
        });
        this.loading = false;
        res(true);
      });
    },
    async loadItems() {
      return new Promise(async (res, rej) => {
        let iks = ["candidates"];

        for (let i = 0; i < iks.length; i++) {
          const f = iks[i];
          let t = this.resource[f];
          if (!t.error) {
            t.forEach((x) => (this.$store.state.i18n.en[x.slug] = x.en));
            t.forEach((x) => (this.$store.state.i18n.ar[x.slug] = x.ar));
            t.forEach((x) => (this.$store.state.i18n.fr[x.slug] = x.fr));
            this[f] = t;
          }
        }

        let ks = this.resourceKeys.filter((x) => x.type == "select" && x.source == "db");

        (async (x) => {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            console.log(f.items);
            f.data = this.resource[f.items].map((x) => {
              return {
                ...x,
                text: x.name ? x.name : x.en ? x.en : "unknown",
                [`${f.name}_id`]: x.id,
              };
            });
          }
          res(true);
        })();
      });
    },
  },
  async created() {
    await this.loadResource();
  },
};
</script>
